import React from "react";
import "./App.css";
import Home from "./components/Home";
import SinglePage from "./components/SinglePage";
import JobOpportunities from "./components/Jobs";
import SingleJob from "./components/SingleJob";
import Board from "./components/Board";
import Login from "./components/Login";
import Recover from "./components/Recover";
import Register from "./components/Register";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateDocument from "./components/PrivateDocument";
import NewsPage from "./components/NewsPage";
import NewsList from "./components/NewsList";
import Ipls from "./components/Ipls";
import Newsletter from "./components/NewsLetter";
import ReservedArea from "./components/ReservedArea";
// import ReservedAreaHome from "./components/ReservedAreaHome";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:pageSlug" element={<SinglePage />} />
          <Route path="/job-opportunities/:jobSlug" element={<SingleJob />} />
          <Route path="/job-opportunities" element={<JobOpportunities />} />
          <Route path="/board" element={<Board />} />
          <Route path="/login" element={<Login />} />
          <Route path="/recover" element={<Recover />} />
          <Route path="/register" element={<Register />} />
          <Route path="/private-document" element={<PrivateDocument/>}/>
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/news" element={<NewsPage/>}/>
          <Route path="/news-list" element={<NewsList/>}/>
          <Route path="/ipls" element={<Ipls/>}/>
          <Route path="/reserved-area" element={<ReservedArea/>}/>
          {/* <Route path="/reserved-area-home" element={<ReservedAreaHome/>}/> */}
        </Routes>
        {/* <Footer /> */}
      </Router>
    </>
  );
}

export default App;
